"use client";

import { BadgeStatus } from "@woba/ds-web-next";
import { useTranslation } from "react-i18next";
import { SeriesItem } from "../types";
import { compareProductOrder } from "@/dashboard/utils/product-order";
import { productBadgeVariant } from "../utils/product-badge-variant";

/**
 * Legenda do gráfico em BadgeStatus do Workbase DS (Figma 6038:3550): fundo,
 * texto e ponto vêm da variante de feedback de cada produto. A linha da série
 * no gráfico usa a mesma cor do ponto (ver productSeriesColor).
 */
export function ChartProductCompetencyLegend({
  series,
}: {
  series: SeriesItem[];
}) {
  const [translate] = useTranslation(["dashboard"]);
  const ordered = [...series].sort((a, b) =>
    compareProductOrder(a.type, b.type),
  );

  return (
    <div
      className="flex flex-wrap gap-2 md:gap-4"
      data-testid="chart-product-competency-legend"
    >
      {ordered.map((s) => (
        <span
          key={s.key}
          title={translate(s.description) as string}
          aria-label={`${translate(s.label)} (${translate(s.description)})`}
          data-variant={productBadgeVariant(s.type)}
        >
          <BadgeStatus
            variant={productBadgeVariant(s.type)}
            label={translate(s.label) as string}
          />
        </span>
      ))}
    </div>
  );
}
